import React from 'react';
import { observer } from 'mobx-react';
import dayjs from 'dayjs';

import { WidgetRow } from 'src/libs/ui-kit/widget-row/WidgetRow';

import { widgetLabels } from '../constants';

import { useProfileWidgetStore } from './StoreProvider';

export const CreatedAtRow = observer(() => {
  const { profile } = useProfileWidgetStore();

  return <WidgetRow label={widgetLabels.profileCreationDate} value={profile?.createdAt || ''} />;
});
